// components/FeedbackActions.js
import React, { useState } from 'react';
import { FiCopy, FiThumbsUp, FiThumbsDown } from 'react-icons/fi';
import styles from './FeedbackActions.module.css';

export default function FeedbackActions({ message, onCopy, onFeedback }) {
  const { id: messageId, feedback } = message;
  const [copied, setCopied] = useState(false);
  const feedbackGiven = feedback === 'THUMBS_UP' || feedback === 'THUMBS_DOWN';

  const handleCopyClick = () => {
    onCopy(); 
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={styles.feedbackActionsContainer}>
      {copied ? (
        <span className={styles.copyFeedback}>Copiado!</span>
      ) : (
        <button title="Copiar" className={styles.feedbackBtn} onClick={handleCopyClick}><FiCopy /></button>
      )}
      {!feedbackGiven && (
        <>
          <button title="Gostei" className={styles.feedbackBtn} onClick={() => onFeedback('THUMBS_UP', messageId)}><FiThumbsUp /></button>
          <button title="Não Gostei" className={styles.feedbackBtn} onClick={() => onFeedback('THUMBS_DOWN', messageId)}><FiThumbsDown /></button>
        </>
      )}
      {feedback === 'THUMBS_UP' && (
        <span title="Feedback positivo enviado" className={`${styles.feedbackBtn} ${styles.sent} ${styles.like}`}><FiThumbsUp /></span>
      )}
      {feedback === 'THUMBS_DOWN' && (
        <span title="Feedback negativo enviado" className={`${styles.feedbackBtn} ${styles.sent} ${styles.dislike}`}><FiThumbsDown /></span>
      )}
    </div>
  );
}